import { FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { preparedIdURL } from 'utils/getURLData'
import { formatDate } from 'utils/formatDate'
import { postAxiosSingle } from 'pages/api/axios'
import { STATIC_URL } from 'constants/data'
import { URL_LIST } from 'constants/url'

import styles from './article-date-views.module.scss'

interface IArticleDateViews {
  date?: Date | string
  comments?: number
  cancelViewsCounting?: boolean
}

const imgPath = {
  date: `${STATIC_URL}/cards/icon_date_grey.svg`,
  eye: `${STATIC_URL}/cards/icon_eye_grey.svg`,
  comment: `${STATIC_URL}/cards/icon_comment.svg`,
}

const ArticleDateViews: FC<IArticleDateViews> = ({
  date,
  comments,
  cancelViewsCounting,
}: IArticleDateViews) => {
  const [views, setViews] = useState('')
  const { asPath } = useRouter()

  useEffect(() => {
    const postViews = async () => {
      const data = {
        id: preparedIdURL(window.location.pathname),
      }
      const result = await postAxiosSingle(URL_LIST.VIEWS_COUNT, {}, data)
      setViews(result?.data?.views ? String(result?.data?.views) : '0')
    }
    if (!cancelViewsCounting) postViews()
  }, [asPath])

  return (
    <div className={styles.videoInfo}>
      {date && (
        <div className={styles.date}>
          <img
            src={imgPath.date}
            decoding="async"
            loading="lazy"
            className={styles.iconDate}
            alt="Дата проведения"
          />
          {formatDate(date)}
        </div>
      )}
      {!cancelViewsCounting && (
        <div className={styles.views}>
          <img
            src={imgPath.eye}
            decoding="async"
            loading="lazy"
            className={styles.iconEye}
            alt="Количество просмотров"
          />
          <p>{views}</p>
        </div>
      )}
      {Boolean(comments) && comments !== 0 && (
        <div className={styles.comments}>
          <img
            src={imgPath.comment}
            decoding="async"
            loading="lazy"
            className={styles.iconComment}
            alt="Комментарии"
          />
          {comments}
        </div>
      )}
    </div>
  )
}

export default ArticleDateViews
